import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import PublicPortfolioPostsListSectionWarRoomPostPreview from './PublicPortfolioPostsListSectionWarRoomPostPreview.vue';
import { categoryData } from '@/components/partials/war-room/WarRoomPostForm/WarRoomPostFormCategories/constants';
import type { Post } from '~/types/graphql';

type PublicPortfolioPostsListSectionProps = {
  initialPosts: Post[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'PublicPortfolioPostsListSection',
  props: {
    initialPosts: null
  },
  setup(__props: any) {

const props = __props as {
  initialPosts: Post[];
};



// Dirty hack to avoid problems in already existed warroom helper components
// We will align this after war room gql migration
const preparedPosts = computed(() =>
  props.initialPosts.map(post => ({
    ...post,
    content: { ...post.content, type: post.__typename },
    category: categoryData[post.category],
    cover_url: post.content.previewImageUrl,
  })),
);

return { __sfc: true,props, preparedPosts, PublicPortfolioPostsListSectionWarRoomPostPreview }
}

})